export const KEY_MAKE = "MakeName";
export const KEY_BODY = "BodyType";



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/const.js